import React, { useState, useEffect } from "react";
import './ValuationCenter.scss'


import img from "../../assets/Infrastructure/Valuation Center/2526 (1).jpeg";
import img1 from "../../assets/Infrastructure/Valuation Center/2526 (2).jpeg";


const images = [img, img1];

const  ValuationCenter = () =>  {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="valuation-center">
      <div className="container">
        <h1 className="page-title">VALUATION CENTER</h1>

        {/* IMAGE CAROUSEL */}
        <div className="clinic-carousel">
          {images.map((img, index) => (
            <div
              key={index}
              className={`slide ${index === current ? "active" : ""}`}
            >
              <img src={img} alt={`Legal Services Clinic ${index + 1}`} />
            </div>
          ))}
        </div>

        
      </div>
    </section>
  );
};

export default ValuationCenter